import { API } from 'src/constants/api';
import { axiosInterceptor } from 'src/utils/interceptors';

export const taskProgressNotesList = async (payload?: any, signal?: any) => {
    const uri = API.TaskProgressNotes.list + payload;
    const response = await axiosInterceptor.get(uri, { signal: signal });
    return response;
};
export const taskProgressNotesUpdate = async (payload?: any) => {
    const uri = API.TaskProgressNotes.update;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const createTaskProgressNotes = async (payload?: any) => {
    const uri = API.TaskProgressNotes.create;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const deleteTaskProgressNotes = async (payload?: any) => {
    const uri = API.TaskProgressNotes.delete + payload;
    const response = await axiosInterceptor.delete(uri);
    return response;
};
